import { css } from '@linaria/core'

export const loadingPlaceholderGradientClass = css`
  animation-duration: 1.8s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: placeHolderShimmer;
  animation-timing-function: linear;
  background: rgba(0, 0, 0, 0.1);
  background: linear-gradient(to right, rgba(0, 0, 0, 0.05) 18%, rgba(0, 0, 0, 0.1) 38%, rgba(0, 0, 0, 0.05) 44%);
  background-size: 1000px 640px;
  cursor: progress;

  @keyframes placeHolderShimmer {
    0% {
      background-position: -468px 0;
    }
    100% {
      background-position: 468px 0;
    }
  }
`

export const loadingPlaceholderTextGradientClass = css`
  display: inline-block;
  min-width: 30px;
  // pretends to be a m-size text place holder
  min-height: 16px;
  border-radius: 4px;

  width: 50%;

  animation-duration: 1.8s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: placeHolderShimmer;
  animation-timing-function: linear;
  background: rgba(0, 0, 0, 0.1);
  background: linear-gradient(to right, rgba(0, 0, 0, 0.05) 18%, rgba(0, 0, 0, 0.1) 38%, rgba(0, 0, 0, 0.05) 44%);
  background-size: 1000px 640px;
  cursor: progress;

  @keyframes placeHolderShimmer {
    0% {
      background-position: -468px 0;
    }
    100% {
      background-position: 468px 0;
    }
  }

  &.vary-by-0 {
    padding-right: 30px;
  }

  &.vary-by-1 {
    padding-right: 10px;
  }

  &.vary-by-2 {
    padding-right: 65px;
  }
`

export const multiLineClass = css`
  display: flex;
  flex-direction: column;
  gap: 8px;

  > *:nth-child(3n + 1) {
    margin-right: 30px;
  }

  > *:nth-child(3n + 2) {
    margin-right: 10px;
  }

  > *:nth-child(3n + 3) {
    margin-right: 65px;
  }
`
